import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NotificationType, UserNotificationItem, UserNotificationSource } from '@shared/models';
import { ModalService } from '../../../modules/modal/modal.service';

@Component({
  selector: 'gcc-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
  standalone: false
})
export class NotificationItemComponent {
  @Input() public notification: UserNotificationItem;
  @Input() public preview: boolean;
  @Input() public allowHide: boolean;

  @Output() public delete = new EventEmitter<string>();
  @Output() public hide = new EventEmitter<string>();
  @Output() public detailsOpen = new EventEmitter<string>();

  public notificationType = NotificationType;
  public notificationSource = UserNotificationSource;

  constructor(private modalService: ModalService) {}

  public handleClose(id: string, e: Event): void {
    e.stopPropagation();

    this.delete.emit(id);
  }

  public handleHide(id: string): void {
    this.hide.emit(id);
  }

  public handleShowDetails({ title, description, type, notificationId }: UserNotificationItem): void {
    if (this.preview) {
      return;
    }

    this.modalService.showNotificationInfo$({ title, description, type }).subscribe();
    this.detailsOpen.emit(notificationId);
  }
}
